import React from "react";
import { useSelector } from "react-redux";
import {
  Paper,
  Grid,
  TableRow,
  TableCell,
  Card,
  TableContainer,
  Table,
  TableHead,
  TableBody,
  CardContent,
  DialogTitle,
  Typography,
} from "@material-ui/core";
import Alert from "@material-ui/lab/Alert";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import LoadingScreen from "../LoadingScreen";
import { headersRowMonthDetailsExams as headersRow } from "../../utils/constants";
import useStyles from "./modalStyle";

const ExamMonthIncomes = ({ id, data, open, handleClose }) => {
  const classes = useStyles();

  const { data: dataAPI, status } = useSelector(
    (state) => state.incomes.monthDetailsExams
  );

  return (
    <Dialog
      maxWidth="md"
      open={open}
      onClose={(e, reason) => {
        if (reason !== "backdropClick" && reason !== "escapeKeyDown") {
          handleClose(id);
        }
      }}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      className={classes.dialog}
    >
      <DialogTitle>
        <div className={classes.dialogTitle}>
          <div className={classes.label}>{`Correction des examens`}</div>
          <div className={classes.close_btn} onClick={() => handleClose(id)}>
            X
          </div>
        </div>
      </DialogTitle>
      {status === "failed" && (
        <>
          <DialogContent className={classes.dialogContent}>
            <Grid
              container
              direction="row"
              justify="space-between"
              alignItems="center"
              className={classes.dialogContentHeader}
            >
              <Paper elevation={0}>
                <Alert severity="error">
                  Un error est servenu: Merci de contacter administrateur
                </Alert>
              </Paper>
            </Grid>
          </DialogContent>
        </>
      )}
      {status === "idle" && <div>Pas de contenu </div>}
      {status === "loading" && <LoadingScreen />}
      {status === "succeeded" && (
        <>
          <DialogContent className={classes.dialogContent}>
            {dataAPI && dataAPI?.data?.examsDetails?.length > 0 ? (
              <>
                <Grid container spacing={3}>
                  <Card>
                    <form autoComplete="off" noValidate>
                      <TableContainer component={Paper}>
                        <Table
                          className={classes.table}
                          aria-label="simple table"
                        >
                          <TableHead>
                            <TableRow>
                              {headersRow.map((tableCell) => {
                                return <TableCell>{tableCell.title}</TableCell>;
                              })}
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {dataAPI?.data?.examsDetails.map((row) => (
                              <TableRow key={row?.examId}>
                                <TableCell component="th" scope="row">
                                  {row?.date}
                                </TableCell>
                                <TableCell>{row?.title}</TableCell>
                                <TableCell style={{ fontWeight: "bold" }}>
                                  {row?.quantity}
                                </TableCell>
                                <TableCell style={{ fontWeight: "bold" }}>
                                  {`${row.unitPrice} pts`}
                                </TableCell>
                                <TableCell
                                  style={{
                                    color: "#00B828",
                                    fontWeight: "bold",
                                  }}
                                >
                                  {`${row.totalPrice} pts`}
                                </TableCell>
                              </TableRow>
                            ))}
                          </TableBody>
                        </Table>
                      </TableContainer>
                    </form>
                  </Card>
                </Grid>
              </>
            ) : (
              <CardContent>
                <Typography variant="body2" color="textSecondary" component="p">
                  This Teacher does not have any items
                </Typography>
              </CardContent>
            )}
          </DialogContent>
        </>
      )}
    </Dialog>
  );
};

export default ExamMonthIncomes;
